// Tag colors for Immomio UI components
import { SystemTag, TagOwnershipType } from '@ui/shared/model';
import {
  ThemeProperties,
  ThemePropertyKeys
} from '../../../infrastructure/theme/symbols';

export function getImmomioTagColors(themeProperties: ThemeProperties) {
  return {
    [SystemTag.VERIFIED]: '#1d9bf0',
    [SystemTag.GUEST]:
      themeProperties?.[ThemePropertyKeys.THEME_COLOR_STATE_500],
    [SystemTag.EXCLUSIVE]: '#808080',
    [SystemTag.OFFLINE]:
      themeProperties?.[ThemePropertyKeys.THEME_COLOR_STATE_900],
    [SystemTag.ANONYMOUS]: '#884dff',
    [SystemTag.CS_PRO]: '#0053BF',
    [SystemTag.TENANT]: '#afb83b',
    [SystemTag.BUYER]: '#afb83b',
    [TagOwnershipType.SHARED]:
      themeProperties?.[ThemePropertyKeys.THEME_COLOR_PRIMARY_ACCENT_DARK],
    [TagOwnershipType.PERSONAL]:
      themeProperties?.[ThemePropertyKeys.THEME_COLOR_PRIMARY_ACCENT_LIGHT],
    [SystemTag.SALES_PROSPECT]:
      themeProperties?.[ThemePropertyKeys.THEME_COLOR_STATE_500],
    [SystemTag.MEMBER]:
      themeProperties?.[ThemePropertyKeys.THEME_COLOR_STATE_100_DARK],
    [TagOwnershipType.DYNAMIC]: '#e7ba14',
    // There is no project specific tag type
    project: '#288b9e',
    [SystemTag.SELF_REGISTERED]: '#ff006c',
    [SystemTag.MERGE_CASE]: '#f6bf25'
  } as const;
}

export type ImmomioTagColor = keyof ReturnType<typeof getImmomioTagColors>;
